import gql from 'graphql-tag';

export default gql`
query adminTimetableSectors {
    adminTimetableSectors {
        id
        name
    }
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/adminTimetableSectors.ts